<template>
  <bonus-dialog>
    <template v-slot:title>
      <div>海量精彩视频 任意充值永久观看</div>
    </template>
    <div class="flex row no-wrap justify-center">
      <div
        class="BonusDialogGuest_btn BonusDialogGuest_btn_cancel"
        @click="cancelHandler">
        先去逛逛
      </div>
      <div
        class="BonusDialogGuest_btn BonusDialogGuest_btn_join"
        @click="joinHandler">
        加入会员
      </div>
    </div>
  </bonus-dialog>
</template>

<script>
import BonusDialog from './BonusDialog'
import { xbbEventType, xbbAction } from '../utils'
export default {
  name: 'BonusDialogGuest',
  components: {
    BonusDialog
  },
  methods: {
    /**
     * 因為ios app 當頁開啟再返回後卻沒有重整，導致彈窗沒被關閉，所以使用這方式強迫關閉
     */
    cancelHandler () {
      xbbAction(xbbEventType.home)
    },
    joinHandler () {
      xbbAction(xbbEventType.joinMember)
    }
  }
}
</script>

<style scoped>
.BonusDialogGuest_btn {
  width: calc(100% - 50px);
  height: 40px;
  margin: 20px 10px 0 10px;
  font-size: 15px;
  font-weight: 700;
  line-height: 40px;
  text-align: center;
  border: none;
  border-radius: 20px;
}

.BonusDialogGuest_btn_cancel {
  color: #262626;
  background-color: #f2f2f2;
}

.BonusDialogGuest_btn_join {
  color: #f2f2f2;
  background-color: #5e626d;
}

.flex {
  display: flex;
}

.row {
  display: flex;
}

.no-wrap {
  flex-wrap: nowrap;
}

.justify-center {
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/xbb/components/BonusDialogGuest.vue